import styled from 'styled-components';

export const UserContainer = styled.div`
  position: relative;
`;

export const UserThumbnail = styled.button`
  font-family: 'Open-Sans', sans-serif;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 3.5rem;
  height: 3.5rem;
  background: #7b93db;
  border-radius: 5rem;
  font-size: 2rem;
  font-weight: bold;
  color: white;
  border: none;
  cursor: pointer;
`;

export const DropdownContainer = styled.div`
  display: none;
  position: absolute;
  top: 4.5rem;
  right: 0;
  width: 100px;
  padding: 1rem;
  background: white;
  border: 1px solid var(--l-grey);
  border-radius: 6px;
  box-shadow: 0px 3px 5px 0px rgba(0, 0, 0, 0.1);
  &.active {
    display: flex;
    justify-content: center;
  }
`;

export const SignOut = styled.button`
  background: none;
  font-weight: bold;
  color: var(--grey);
  border: none;
  font-size: 1.4rem;
  transition: color 0.2s;
  cursor: pointer;
  &:hover {
    color: var(--d-grey);
  }
`;
